<template>
  <div style="width: 100%">
    <el-table :data="robotlist" border style="width: 100%" resizable>
    
      <el-table-column fixed prop="fbsPair" label="fbsPair" width="180">
      </el-table-column> 
       <el-table-column  prop="id" label="id" width="100">
      </el-table-column>
      <el-table-column prop="userId" label="userId" width="120">
      </el-table-column>
      <el-table-column prop="huoPair" label="huoPair" width="120">
      </el-table-column>
      <el-table-column prop='frontCoinAmount' label="frontCoinAmount" width="220">
      </el-table-column>
      <el-table-column prop='frontCoinFroze' label="frontCoinFroze" width="220">
      </el-table-column>
      <el-table-column prop='coinAmount' label="coinAmount" width="220">
      </el-table-column>
      <el-table-column prop='coinFroze' label="coinFroze" width="220">
      </el-table-column>

      <el-table-column prop="mirrorConfig" label="mirrorConfig" width="320">
      </el-table-column>
      <el-table-column prop="bargainConfig" label="bargainConfig" width="240">
      </el-table-column>
      <el-table-column
        prop="bargainMirrorConfig"
        label="bargainMirrorConfig"
        width="200"
      >
      </el-table-column>
      <el-table-column label="switch">
        <template slot-scope="scope">
          <el-button
            size="small"
            :type="scope.row ? 'success' : 'danger'"
            icon="el-icon-check"
            circle
            @click="changeBtn(scope.row, $event)"
          ></el-button>
        </template>
      </el-table-column>

      <el-table-column prop="secretKey" label="secretKey" width="300">
      </el-table-column>
      <el-table-column prop="accessKey" label="accessKey" width="300">
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="150" fontsize="14px">
        <template slot-scope="scope">
          <el-button
            size="small"
            type="primary"
            circle
            icon="el-icon-edit"
            @click="handleEdit(scope.$index, scope.row)"
          ></el-button>
          <el-button
            size="small"
            type="danger"
            circle
            icon="el-icon-delete"
            @click="handleDelete(scope.$index, scope.row)"
          ></el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 编辑机器人信息 -->
    <el-dialog
      title="修改机器人信息"
      width="800px"
      :visible.sync="dialogVisibleChange"
      @close="closeDialog"
      :before-close="handleClose"
    >
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        label-width="160px"
        class="demo-ruleForm"
      >
        <el-form-item label="huoPair" prop="huoPair" >
          <el-input
            v-model.trim="ruleForm.huoPair"
            placeholder="请输入huoPair"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item label="fbsPair" prop="fbsPair" >
          <el-input
            v-model.trim="ruleForm.fbsPair"
            placeholder="请输入fbsPair"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item label="mirrorConfig" prop="mirrorConfig">
          <el-input type="textarea"
            v-model.trim="ruleForm.mirrorConfig"
            placeholder="请输入mirrorConfig"
          ></el-input>
        </el-form-item>
        <el-form-item label="bargainConfig" prop="bargainConfig">
          <el-input type="textarea"
            v-model.trim="ruleForm.bargainConfig"
            placeholder="请输入bargainConfig"
          ></el-input>
        </el-form-item>
        <el-form-item label="bargainMirrorConfig" prop="bargainMirrorConfig">
          <el-input type="textarea"
            v-model.trim="ruleForm.bargainMirrorConfig"
            placeholder="请输入bargainMirrorConfig"
          ></el-input>
        </el-form-item>
        <el-form-item label="userId" prop="userId">
          <el-input
            v-model.trim="ruleForm.userId"
            placeholder="请输入userId"
          ></el-input>
        </el-form-item>
        <el-form-item label="secretKey" prop="secretKey">
          <el-input style="width: 500px;"
            v-model.trim="ruleForm.secretKey"
            placeholder="请输入secretKey"
          ></el-input>
        </el-form-item>
        <el-form-item label="accessKey" prop="accessKey">
          <el-input style="width: 500px;"
            v-model.trim="ruleForm.accessKey"
            placeholder="请输入accessKey"
          ></el-input>
        </el-form-item>
        <span slot="footer" class="dialog-footer"> </span>
        <el-form-item label-width="240px">
          <el-button type="primary" @click="updateRobotInfo('ruleForm')"
            >确定修改</el-button
          >
          <el-button @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
<!-- 机器人开关修改 -->
    <el-dialog
      :title="'修改' + pair + '机器人开关'"
      width="900px"
      :visible.sync="dialogSwitch"
      @close="closeDialog"
      :before-close="handleClose"
    >
    <div>
      <div style="margin-bottom: 5px;">镜像开关：<el-switch :value="mirrorStatus" @change="mirrorSwitch($event)"></el-switch></div>
      <div>自成交开关：
        <el-input-number v-model="mirrorBargainDelayInfo" style="margin-right: 20px;"></el-input-number>
        <el-button type="primary" @click="updateMirrorBargainDelayInfo" style="margin-right: 20px;">修改成交开关DelayInfo</el-button>
        <el-switch :value="mirrorBargainStatus" @change="mirrorBargainSwitch($event)"></el-switch></div>
    </div>
    


      <div style="margin-left: 700px; margin-bottom: 20px; margin-top: -40px">
        <el-button @click="open" type="primary">添加一个开关</el-button>
        
      </div>
      <el-divider></el-divider>
      <div>
        <el-form ref="form"  :inline="true">
        <template v-for="item in switchForm">
          <el-form-item :label="item.pair" label-width="120px">
            <el-input-number v-model="item.delayInfo"></el-input-number>
            <el-button
              size="small"
              type="primary"
              @click="updatePairInfo(item.delayInfo, item.pair)"
              >修改</el-button
            >
            <el-button
              size="small"
              type="danger"
              @click="delPairInfo(item.pair)"
              >删除</el-button
            >
            <el-switch
              :value="item.robotSwitch == 'true' ? true : false"
              @change="changeRobotSwitch(item,item.robotSwitch, item.pair)"
            ></el-switch>
          </el-form-item>
          <!-- <el-form-item>
            <el-divider direction='vertical'></el-divider>
          </el-form-item>
           -->
          <!-- <el-form-item label="开关状态" label-width="120px">
            <el-switch
              :value="item.robotSwitch == 'true' ? true : false"
              @change="changeRobotSwitch(item.robotSwitch, item.pair)"
            ></el-switch>
          </el-form-item> -->
        </template>

        <el-form-item> </el-form-item>
      </el-form>
      </div>
      <!-- 内层dialog   添加机器人开关 -->
      <el-dialog
        width="30%"
        :title="'添加  ' + addPair + '  开关详情'"
        :visible.sync="innerVisible"
        append-to-body
      >
        <el-form>
          <el-form-item>
            <span>{{ addPair }}</span>
          </el-form-item>
          <el-form-item>
            <el-input
              :placeholder="'请输入后缀,例如xx,显示为' + addPair + 'xx'"
              v-model="delayName"
            ></el-input>
          </el-form-item>

          <el-form-item>
            <el-input
              placeholder="请输入开关延迟时间（毫秒）"
              v-model="parameter"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              @click="addOneSwitch"
              type="primary"
              size="small"
              style="margin-left: 430px"
              >确定添加开关</el-button
            >
          </el-form-item>
        </el-form>
      </el-dialog>
    </el-dialog>
  </div>
</template>

<script>
import { CollapseItem } from "element-ui";
import { mapGetters, mapActions, mapMutations, mapState } from "vuex";
export default {
  name: "CreateContent",
  props: ["page", "size", "totalCount"],
  data() {
    return {
      mirrorStatus:false,
      mirrorBargainStatus:false,
      dialogVisibleChange: false,
      dialogSwitch: false,
      innerVisible: false,
      mirrorBargainDelayInfo:'',
      symbolName:'',
      front:'',
      delayName: "",
      parameter: "",
      pair: "",
      addPair: "",
      switchType:'',
      switchForm:[],
      ruleForm: {
        //   id: 1,
        huoPair: "",
        fbsPair: "",
        mirrorConfig: "",
        bargainConfig: "",
        bargainMirrorConfig: "",
        userId: "",
        secretKey:
          "f81858fe95ba0f9d4ca0f528edc5c38489ecafd0d32c6f5c8de7705cf20c0f58",
        accessKey:
          "892092131a8a591c9198a6da444e0c415e14f182fbfb1f76c7f9371b21daa018",
      },
      infoObj: [],
      online: 0,
      secretKey:
        "f81858fe95ba0f9d4ca0f528edc5c38489ecafd0d32c6f5c8de7705cf20c0f58",
      accessKey:
        "892092131a8a591c9198a6da444e0c415e14f182fbfb1f76c7f9371b21daa018",
    };
  },
  mounted() {
    this.getData({page:this.page,size:this.size});
  },
  computed: {
    ...mapState("robot", ["robotlist"]),
    frontStr(){
      return this.robotlist.frontCoinAmount+this.robotlist.fbsPair.split("_")[0]
    }
  },
  methods: {
    ...mapActions("robot", [
      "getlist",
      "delOne",
      "updateInfo",
      "getSwitchObjData",
      "asyncUpdateRobotPiar",
      "asyncUpdateRobotSwitch",
      "asyncDelOneRobotSwitch",
      "asyncAddRobotSwitch",'getMirrorSwitch','updateMirrorSwitch','getSelfDealSwitch','updateSelfDealSwitch','updateSelfDealInfo'
    ]),
  mirrorSwitch(e){
      this.$confirm('确定修改镜像开关?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async() => {
          const res=await  this.updateMirrorSwitch({pair:this.symbolName,parameter:e})
    if(res.code==0){
      this.mirrorStatus=e
    }
          this.$message({
            type: 'success',
            message: '修改成功!'
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });          
        });
   
    },
    mirrorBargainSwitch(e){
      this.$confirm('确定修改自成交开关?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async() => {
          const res=await  this.updateSelfDealSwitch({pair:this.symbolName,parameter:e})
        if(res.code==0){
          this.mirrorBargainStatus=e
        }
          this.$message({
            type: 'success',
            message: '修改成功!'
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });          
        });
    },
   async updateMirrorBargainDelayInfo(){
      console.log('this.symbol',this.symbolName,this.mirrorBargainDelayInfo);
     const res=await  this.updateSelfDealInfo({pair:this.symbolName,parameter:this.mirrorBargainDelayInfo})
    if(res.code==0){
          this.$message({
            type: 'success',
            message: '修改成功!'
          });
    }
    },
    async getData(data={}) {
      const res = await this.getlist({ pair: "",...data});
    },
    handleDelete(index, row) {

      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const res = await this.delOne(row.id);
          if (res.data == 1) {
            this.$message.success("操作成功");
            this.getData({page:this.page,size:this.size});
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
      },
    handleEdit(index, row) {
      this.dialogVisibleChange = true;
      const id = row.id;
      this.ruleForm = { ...row };
    },
    handleOnlineChange(row, e) {
    },
    async updateRobotInfo() {
      const res = await this.updateInfo(this.ruleForm);
      if (res.msg == "success") {
        this.getData({page:this.page,size:this.size});
        this.$message.success("Info修改成功");
        this.dialogVisibleChange = false;
      }
    },
    async changeBtn(row, e) {
      // this.getMirrorSwitch()
      this.symbolName=row.fbsPair
      const mirrorData=await this.getMirrorSwitch(row.fbsPair)
      const mirrorBarginData=await this.getSelfDealSwitch(row.fbsPair)
      console.log('zichengjiao',mirrorBarginData);
      if(mirrorBarginData.data.robotSwitch=='true'){
        this.mirrorBargainStatus=true
      }else{
        this.mirrorBargainStatus=false
      }
      
      this.mirrorBargainDelayInfo=mirrorBarginData.data.delayInfo
      ////
     this.mirrorStatus=mirrorData.data
      this.switchType=row.fbsPair
      this.addPair = row.fbsPair;
      this.pair = row.fbsPair;
      const res = await this.getSwitchObjData({ pair: row.fbsPair });
      if (res.msg == "success") {
        if (this.dialogSwitch == false) {
          this.switchForm = {};
        }
        for (let i = 0; i < res.data.length; i++) {
          this.$set(this.switchForm, res.data[i].pair, res.data[i]);
        }
      }

      // const switchObj = res.data[0];
      this.infoObj = res.data[1];
 

      this.dialogSwitch = true;
    },
    updatePairInfo(info, pair) {
      this.$confirm("确定修改该开关配置?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const res = await this.asyncUpdateRobotPiar({
            pair,
            parameter: info,
          });

          if (res.msg == "success") {
            this.$message({
              type: "success",
              message: "修改配置成功!",
            });
            this.getData({page:this.page,size:this.size});
          }
        })
        .catch(() => {
          info = false;
          this.$message({
            type: "info",
            message: "已取消修改",
          });
        });
    },
    async changeRobotSwitch(item,status, pair) {
      if (status == "false") {
        const res = await this.asyncUpdateRobotSwitch({
          pair:item.pair,
          parameter: true,
        }); 
        if (res.msg == "success") {
          const {data}=await  this.getSwitchObjData({pair:this.switchType})
          // this.switchForm={...detailData}
          this.switchForm=data
        }
      }
      if (status == "true") {
        const res = await this.asyncUpdateRobotSwitch({
          pair:item.pair,
          parameter: false,
        });
        if (res.msg == "success") {
          const {data}=await  this.getSwitchObjData({pair:this.switchType})
      // this.switchForm={...detailData}
          this.switchForm=data
          this.$message({
            type: "success",
            message: "修改状态成功!",
          });
          // this.getData()
          // this.dialogSwitch = false;
        }
      }
    },
    delPairInfo(pair) {
      this.$confirm("确定删除该开关相应信息?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const res = await this.asyncDelOneRobotSwitch(pair);
          if (res.msg == "success") {
            this.$message.success("操作成功");
            this.dialogSwitch = false;
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    async addOneSwitch() {
      const res = await this.asyncAddRobotSwitch({
        pair: this.addPair,
        delayName: this.delayName,
        parameter: this.parameter,
      });
      if (res.msg == "success") {
        this.innerVisible = false;
        // this.getSwitchObjData();
        this.addPair = "";
        this.parameter = "";
        this.delayName = "";
        this.$message.success("添加成功");
      }
    },
    open() {
      this.innerVisible = true;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert("submit!");
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    closeDialog() {},
  },
};
</script>

<style lang="less" scoped>
.el-form-item__content {
  width: 100%;
  display: flex;
  justify-content: space-between;
  .el-button {
    margin-left: 40px;
  }
  .el-switch {
    margin-left: 40px;
  }
  .el-input {
    display: inline-block;
    // width: 300px;
  }
}
</style>
